export default class CookieUtils{
  static getCookie(key){
    var value = "; " + document.cookie;
    var parts = value.split("; " + key + "=");
    if (parts.length > 1) return parts.pop().split(";").shift();
  }

  static setCookie(key, value, expire = null, path = '/'){
    const cookie = expire === null ?
      `${key}=${value}; path=${path}` :
      `${key}=${value}; expires=${expire}; path=${path}`;

    document.cookie = cookie;
  }
}
